 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","api-keys~create-global-note~create-preparations~create-substances~notifications~route-of-administati~3fc77ac4":"api-keys~create-global-note~create-preparations~create-substances~notifications~route-of-administati~3fc77ac4","api-keys":"api-keys","create-global-note~create-preparations~create-substances~single-global-note~single-preparations~sing~33a66621":"create-global-note~create-preparations~create-substances~single-global-note~single-preparations~sing~33a66621","create-global-note":"create-global-note","create-preparations~single-preparations":"create-preparations~single-preparations","create-preparations":"create-preparations","create-substances~single-substances":"create-substances~single-substances","create-substances":"create-substances","single-global-note~single-preparations~single-substances":"single-global-note~single-preparations~single-substances","single-preparations":"single-preparations","single-substances":"single-substances","single-global-note":"single-global-note","notifications":"notifications","route-of-administation":"route-of-administation","users":"users","wada-classification":"wada-classification","dictionary":"dictionary","export":"export","global-notes":"global-notes","importdata":"importdata","preparations":"preparations","substances":"substances"}[chunkId]||chunkId) + "." + {"404":"16df9428","api-keys~create-global-note~create-preparations~create-substances~notifications~route-of-administati~3fc77ac4":"9a10bc9a","api-keys":"ce20cea8","create-global-note~create-preparations~create-substances~single-global-note~single-preparations~sing~33a66621":"bc6abfde","create-global-note":"74cef0b2","create-preparations~single-preparations":"98097fd8","create-preparations":"a817d2d1","create-substances~single-substances":"c46ee288","create-substances":"3df68fc2","single-global-note~single-preparations~single-substances":"d2c061c9","single-preparations":"41d7d84d","single-substances":"fd5c696a","single-global-note":"531e3266","notifications":"eeb05624","route-of-administation":"6a6d15cd","users":"d45eb564","wada-classification":"e6fb883e","dictionary":"e33887dc","export":"cc0291c2","global-notes":"617cc850","importdata":"1951d316","preparations":"0a6c6995","substances":"b0985ae0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"api-keys":1,"create-global-note~create-preparations~create-substances~single-global-note~single-preparations~sing~33a66621":1,"create-global-note":1,"create-preparations~single-preparations":1,"create-substances~single-substances":1,"create-substances":1,"single-global-note~single-preparations~single-substances":1,"single-preparations":1,"single-substances":1,"single-global-note":1,"notifications":1,"route-of-administation":1,"users":1,"wada-classification":1,"dictionary":1,"global-notes":1,"importdata":1,"preparations":1,"substances":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","api-keys~create-global-note~create-preparations~create-substances~notifications~route-of-administati~3fc77ac4":"api-keys~create-global-note~create-preparations~create-substances~notifications~route-of-administati~3fc77ac4","api-keys":"api-keys","create-global-note~create-preparations~create-substances~single-global-note~single-preparations~sing~33a66621":"create-global-note~create-preparations~create-substances~single-global-note~single-preparations~sing~33a66621","create-global-note":"create-global-note","create-preparations~single-preparations":"create-preparations~single-preparations","create-preparations":"create-preparations","create-substances~single-substances":"create-substances~single-substances","create-substances":"create-substances","single-global-note~single-preparations~single-substances":"single-global-note~single-preparations~single-substances","single-preparations":"single-preparations","single-substances":"single-substances","single-global-note":"single-global-note","notifications":"notifications","route-of-administation":"route-of-administation","users":"users","wada-classification":"wada-classification","dictionary":"dictionary","export":"export","global-notes":"global-notes","importdata":"importdata","preparations":"preparations","substances":"substances"}[chunkId]||chunkId) + "." + {"404":"76dd2df7","api-keys~create-global-note~create-preparations~create-substances~notifications~route-of-administati~3fc77ac4":"31d6cfe0","api-keys":"81dffc5b","create-global-note~create-preparations~create-substances~single-global-note~single-preparations~sing~33a66621":"49f1f6ba","create-global-note":"f11adc6b","create-preparations~single-preparations":"a01df168","create-preparations":"31d6cfe0","create-substances~single-substances":"e81109c4","create-substances":"3ee7eb68","single-global-note~single-preparations~single-substances":"c9ddf91a","single-preparations":"688bfc87","single-substances":"b1eb3a46","single-global-note":"07dacb9f","notifications":"04dfebbb","route-of-administation":"2239f860","users":"df2bdb8b","wada-classification":"1bf1d4ac","dictionary":"f99a7dd9","export":"31d6cfe0","global-notes":"6fb5f3a0","importdata":"ce2feaa9","preparations":"74d119b9","substances":"74d119b9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
